import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import pick from '@nullvoxpopuli/ember-composable-helpers/helpers/pick';
import classNames from 'volta/helpers/class-names';
import guid from 'volta/helpers/guid';
import orElse from 'volta/helpers/or-else';
import BvChoice from 'volta/components/bv-choice';
import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';
interface BvRadioSignature {
    Args: {
        ariaDescribedBy?: string;
        checked?: boolean;
        disabled?: boolean;
        helpText?: string;
        id?: string;
        label?: ContentValue;
        labelClass?: string;
        labelHidden?: boolean;
        name?: boolean;
        onBlur?: () => void;
        onChange?: () => void;
        onFocus?: () => void;
        onMouseOut?: () => void;
        onMouseOver?: () => void;
        value?: boolean;
    };
    Element: HTMLSpanElement;
}
const BvRadioComponent: TOC<BvRadioSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  {{#let (orElse @id (concat (guid) 'BvCheckbox')) as |id|}}
    <BvChoice
      @disabled={{@disabled}}
      @helpText={{@helpText}}
      @id={{id}}
      @label={{@label}}
      @labelHidden={{@labelHidden}}
      @labelClass={{@labelClass}}
      @onMouseOut={{@onMouseOut}}
      @onMouseOver={{@onMouseOver}}
      as |bvChoice|
    >
      <span class='bv-radio' ...attributes>
        {{! template-lint-disable no-duplicate-id }}
        <input
          aria-describedby={{classNames @ariaDescribedBy bvChoice.helpTextId bvChoice.errorId}}
          checked={{@checked}}
          class='bv-radio__input'
          disabled={{@disabled}}
          id={{id}}
          name={{@name}}
          type='radio'
          value={{@value}}
          {{on 'click' (pick 'currentTarget.checked' (optional (unless @disabled @onChange)))}}
          {{on 'focus' (optional @onFocus)}}
          {{on 'blur' (optional @onBlur)}}
        />
        <span class='bv-radio__backdrop'></span>
        <span class='bv-radio__icon'></span>
      </span>
    </BvChoice>
  {{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvRadioComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvRadio: typeof BvRadioComponent;
        'bv-radio': typeof BvRadioComponent;
    }
}
